import React from 'react';
import { CtaButton } from './CtaButton';
const marquee = ['SESSIONS', 'DRILLS', 'PROGRESSIONS', 'ASSESSMENTS', 'PORTFOLIOS', 'TACTICS', 'ALL ORGANIZED'];
export function FinalCta() {
  return <section className="bg-ink py-16 md:py-24" aria-labelledby="final-cta-title" data-id="element-66" data-mp="19g0dhjtkbyky">
      <div className="mx-auto max-w-4xl px-5 text-center md:px-8" data-id="element-67" data-mp="15cu9kitxajhn">
        <h2 id="final-cta-title" className="font-display text-3xl font-extrabold uppercase leading-tight text-slate-400 md:text-5xl" data-id="element-68" data-mp="15fq7i75rt863">
          Your next session can keep being improvised.
        </h2>
        <p className="mt-3 font-display text-4xl font-extrabold uppercase leading-tight text-white md:text-6xl" data-id="element-69" data-mp="1t3g5xcukefbt">
          Or you can finally have a real system.
        </p>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-slate-300 md:text-lg" data-id="element-70" data-mp="223mfwor20x68">
          Join hundreds of coaches across the USA and Latin America who already plan their entire
          season in under 5 minutes — and show up to every session with confidence, purpose, and a
          system that works.
        </p>

        <ul className="mt-10 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-[11px] font-bold uppercase tracking-[0.2em] text-slate-500 md:text-xs" data-id="element-71" data-mp="s5qobwnsb6u7">
          {marquee.map((item, index) => <li key={item} data-id="element-72" data-mp="123mxwk12ptq7" data-mpi={index}>
              {item}
              {index < marquee.length - 1 && <span className="pl-3 text-accent" data-id="element-73" data-mp="1658ikrjuncay">/</span>}
            </li>)}
        </ul>

        <div className="mt-12 rounded-2xl border border-line bg-ink-800 p-6 md:p-10" data-id="element-74" data-mp="1b2rwfqcmxn2d">
          <p className="font-display text-2xl font-extrabold uppercase tracking-wide text-white md:text-3xl" data-id="element-75" data-mp="1ftqdwt9d0r77">
            ⚾ Baseball 360 — Complete Vault
          </p>
          <p className="mt-1 text-sm text-slate-300" data-id="element-76" data-mp="1kv7d8kc745lo">15 Volumes + 6 Bonuses · Lifetime Access</p>
          <p className="mt-6 font-display text-6xl font-extrabold leading-none text-white md:text-7xl" data-id="element-77" data-mp="1pqd0bmhc3qbc">
            <s className="mr-3 text-3xl text-slate-500 md:text-4xl" data-id="element-78" data-mp="1troorooh25hy">$90</s>$27
            <span className="ml-2 align-middle text-base font-semibold text-slate-400 md:text-lg" data-id="element-79" data-mp="3quxagnj5g10l">
              one-time
            </span>
          </p>

          <div className="mt-8 flex justify-center" data-id="element-80" data-mp="3i4lkim56so0">
            <CtaButton data-id="element-81" data-mp="3jplknr873t9">🚀 I want Baseball 360 now</CtaButton>
          </div>
          <div className="mt-4 space-y-1 text-xs text-slate-400 md:text-sm" data-id="element-82" data-mp="3uuplr7zxgl9n">
            <p data-id="element-83" data-mp="depuvg572pxn">🔒 Secure Payment · ⚡ Instant Access · 🛡️ 7-Day Guarantee</p>
            <p data-id="element-84" data-mp="8gy10gkzotqt">💳 Card · Google Pay · Apple Pay</p>
          </div>
        </div>
      </div>
    </section>;
}